export default __webpack_public_path__ + "static/poster-6e6bef651fcc3b5695178859131b2ef2.png";